<template>
    <app-modal modal-id="details-view-modal" modal-size="fullscreen" modal-alignment="top" @close-modal="closeModal">
        <template slot="header">
            <h4>All Participant Details</h4>
            <button type="button" class="close outline-none" data-dismiss="modal" aria-label="Close">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <template v-if="participantData.participents.length">
                <div class="d-flex flex-wrap align-items-center justify-content-between"
                     :class="{'mb-primary': participantData.participents.length > 1 && index !== participantData.participents.length - 1}"
                     v-for="(participant, index) in participantData.participents"
                     :key="index">
                    <div class="media d-flex align-items-center" v-if="participant.person">

                        <app-avatar
                                :title="participant.person.name"
                                class="mr-2"
                                avatar-class="avatars-w-40"
                                :img="participant.person.profile_picture ?
                            participant.person.profile_picture.path :
                            participant.person.profile_picture"
                        />

                        <div class="media-body" v-if="participant.person">
                            {{ participant.person.name }}
                            <!--                            <p class="text-muted font-size-90 mb-0">-->
                            <!--                                {{ participant.detail }}-->
                            <!--                            </p>-->
                        </div>
                    </div>
                    <div v-if="participant.person">
                        <app-badge :label="participant.person.contact_type.name"
                                   :className="`badge-sm badge-pill badge-${participant.person.contact_type.class}`"/>
                    </div>
                </div>
            </template>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click.prevent="closeModal">
                {{ $t('close') }}
            </button>
        </template>
    </app-modal>
</template>

<script>
    export default {
        name: "ViewAllParticipants",
        props:['participantData'],
        data() {
            return {

            }
        },
        methods: {
            closeModal(value){
                this.$emit('close-modal', value);
            },
        }
    }
</script>